import React, { Component } from "react";
import { connect } from "react-redux";
import {
	AIRLINE_SEARCH_FLIGHTS_DONE,
	AIRLINE_SEARCH_FLIGHTS_PENDING,
	AIRLINE_SEARCH_FLIGHTS_FETCHING,
	AIRLINE_SEARCH_FLIGHTS_ERROR
} from "../shared/constants";

const classNameTranslation = {
	[AIRLINE_SEARCH_FLIGHTS_FETCHING]: "loader-fetching",
	[AIRLINE_SEARCH_FLIGHTS_PENDING]: "loader-pending",
	[AIRLINE_SEARCH_FLIGHTS_DONE]: "loader-done",
	[AIRLINE_SEARCH_FLIGHTS_ERROR]: "loader-done"
};

class FlightsFoundWrapper extends Component {
	showFlightsSumFromAirline(airline) {
		if (this.props.flightsFound)
			return `(${
				this.props.flightsFound.filter(flight => {
					if (airline === "others" && flight.airlineTarget === "others") {
						return true;
					} else {
						return flight.airline === airline;
					}
				}).length
			})`;
	}

	showFlightStatusText() {
		if (this.props.airlinesFetched) return null;

		if (this.props.airlines && this.props.airlines.length > 0)
			return (
				<div className="airports-headers">
					<h3 className="lead">Quase lá! Encontramos voos na</h3>
				</div>
			);

		return (
			<div className="airports-headers">
				<h3 className="lead">Oba! Buscando todos os voos disponíveis para o seu trecho</h3>
			</div>
		);
	}

	showFlightStatus() {
		if (this.props.airlinesFetched) {
			const flightSearch =
				this.props.flightsFound.length > 1 ? "VOOS ENCONTRADOS" : "VOO ENCONTRADO";

			return (
				<div className="airports-preloader">
					<h3 className="lead">{`${this.props.flightsFound.length} ${flightSearch}`}</h3>
				</div>
			);
		}

		if (this.props.airlines)
			return (
				<div className="airports-preloader">
					{this.props.airlines.map((airline, i) => (
						<div key={i} className="airport-item">
							<span className={`loader ${classNameTranslation[airline.fetchStatus]}`}>
								{airline.fetchStatus == AIRLINE_SEARCH_FLIGHTS_DONE ? (
									<span className="icon-check" />
								) : null}
								{airline.fetchStatus == AIRLINE_SEARCH_FLIGHTS_ERROR ? (
									<span className="icon-close" />
								) : null}
							</span>
							<span className="airport-label">
								{airline.label === "others" ? "outras" : airline.label}{" "}
								{this.showFlightsSumFromAirline(airline.label)}
							</span>
						</div>
					))}
				</div>
			);
	}

	render() {
		if (this.props.searchStatus.partLoading) {
			return (
				<div className="airport-wrapper">
					<div className="airports-headers hidden-xs">
						<h3 className="lead">Buscando novas combinações de voos na</h3>
					</div>

					<div className="airports-preloader">
						<div className="airport-item">
							<span className="loader loader-fetching" />
							<span className="airport-label">{this.props.searchStatus.partLoading}</span>
						</div>
					</div>
				</div>
			);
		}

		return (
			<div className="airport-wrapper">
				{this.showFlightStatusText()}
				{this.showFlightStatus()}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	flightsFound: state.flights.inbound.concat(state.flights.outbound),
	searchStatus: state.searchStatus,
	airlinesFetched: state.searchStatus.progress == 100,
	airlines: state.searchStatus.airlines || []
});

export default connect(mapStateToProps, {})(FlightsFoundWrapper);
